import { render, staticRenderFns } from "./UsersDelete.vue?vue&type=template&id=2d57e736&scoped=true&"
import script from "./UsersDelete.vue?vue&type=script&lang=js&"
export * from "./UsersDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d57e736",
  null
  
)

export default component.exports